import { FlagIcon } from "@xola/icons";
import { Skeleton } from "@xola/ui-kit";
import clsx from "clsx";
import { range } from "lodash";
import React from "react";

export const CheckInPurchaseGuestListSkeleton = () => {
    const guests = range(0, 5).map((_, index) => ({ id: index }));

    return (
        <Skeleton height={410}>
            <div className="flex items-center justify-between rounded-t-lg bg-gray-light p-4">
                <div className="text-left">
                    <p className="text-sm font-bold leading-p1 text-gray">
                        <FlagIcon /> Group
                    </p>
                    <h3 className="mt-1 h-5 w-25 rounded bg-gray" />
                </div>
                <div className="flex-shrink-0">
                    <span className="flex">
                        <CheckInButtonSkeleton />
                        <CheckInButtonSkeleton />
                    </span>
                </div>
            </div>

            <div className="mt-4 h-80 divide-y divide-gray-light overflow-y-auto">
                {guests.map((guest, index) => {
                    return (
                        <div key={guest.id} className="flex w-96 items-center justify-between p-4 py-2">
                            <div className="flex items-center space-x-2">
                                {index === 0 ? <FlagIcon /> : <div className="ml-3.5" />}
                                <div className="h-5 w-16 rounded bg-gray-light" />
                            </div>
                            <div className="flex items-center space-x-2">
                                <span className="flex">
                                    <CheckInButtonSkeleton isGuestLevelButton />
                                    <CheckInButtonSkeleton isGuestLevelButton />
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>
        </Skeleton>
    );
};

const CheckInButtonSkeleton = ({ isGuestLevelButton = false }) => {
    const background = isGuestLevelButton ? "bg-gray-light" : "bg-gray";
    return <div className={clsx(background, "mt-1 mr-2 h-7.5 rounded px-5 py-2")} />;
};
